export default __webpack_public_path__ + "images/emptyAlarm.3ebaee60c71028f998047239126eb13a.svg";